const appRouters: Array<any> = [{
    path: '/counterstatistics',
    name: 'counterstatistics',
    sort: 3,
    meta: { title: 'app.Menu.CounterStatistics', showAlways:true,  icon: 'ios-apps' },
    component: () => import('../shared/main/index.vue'),
    children: [
        {
            path: 'containershipmentstatistics', meta: { title: 'app.ContainerShipmentStatistics', access: ['RIMS.ContainerShipmentStatistics'], icon: '', defaultChild: 'containershipmentstatistics.list' },
            name: 'containershipmentstatistics', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'containershipmentstatistics', meta: { title: 'app.ContainerShipmentStatistics', access: ['RIMS.ContainerShipmentStatistics'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'containershipmentstatistics.list', component: () => import('./containershipmentstatistics/index.vue'),
                },
            ]
        },
        {
            path: 'freightforwardertowingcontainerstatistics', meta: { title: 'app.FreightForwarderTowingContainerStatistics', access: ['RIMS.FreightForwarderTowingContainerStatistics'], icon: '', defaultChild: 'freightforwardertowingcontainerstatistics.list' },
            name: 'freightforwardertowingcontainerstatistics', component: () => import('@/components/parent-view.vue'),
            children: [
                {
                    path: 'freightforwardertowingcontainerstatistics', meta: { title: 'app.FreightForwarderTowingContainerStatistics', access: ['RIMS.FreightForwarderTowingContainerStatistics'], hideInMenu: true, hideInBread: true, icon: '' },
                    name: 'freightforwardertowingcontainerstatistics.list', component: () => import('./freightforwardertowingcontainerstatistics/index.vue'),
                },
            ]
        },
    ]
}
]

export default appRouters